<template>
  <div role="tablist">
  	<!-- <pre> stuff=>{{this.$route.path}} </pre> -->
    <b-card border-variant="light" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="info">New Task
          <b-badge> {{kount}}</b-badge>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <ul id="example-1">
            <li v-for="change in this.changed">
              {{ change.name }} : {{ change.value}}
            </li>
          </ul>
          <div class="text-center">
            <button v-if="kount" class="btn btn-primary" @click.prevent="onSubmit">Send to Device</button>
            <button v-if="kount" class="btn btn-secondary" @click.prevent="onReset">Reset</button>
            <!-- <button @click.prevent="reRender">Reset</button> -->
            <!--             <pre>changed: {{changed}}</pre>
            <pre>changes: {{changes}}</pre> -->
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card border-variant="light" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-2 variant="info">Previous Tasks</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>{{ text }}</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card border-variant="light" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-3 variant="info">More info.</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>{{ text }}</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
    changed: {
      type: Array,
    },
    changes: {
      type: Object,
    },
  },
  data() {
    return {


      text: `...`,
    }
  },
  computed: {
    kount: function() {
      return this.changed.length
    }
  },

  methods: {
    onSubmit() {
      this.submitted = true;

console.log("ID " + this.device.id);

      this.device.change_list = this.changes;
      this.$validator.validate().then(valid => {
        if (valid) {
          let uri = `/api/devices/${this.device.id}`;
          axios.patch(uri, this.device).then((response) => {


            if (response.data.success === true) {
              this.makeToast('info', 'Router updated.');
              window.location.reload();
              // this.$forceUpdate();
            } else {
              this.makeToast('danger', 'Unable to update device.');
            }

          });

        }
      });
    },
    makeToast(variant = null, message = null) {

      this.$bvToast.toast(message, {
        // title: `Device Updated ${variant || 'default'}`,
        title: `Notification:`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true
      });
      // toast.show();
    },
    onReset(){
    	 window.location.reload();
    },

  },



}
</script>
